import classNames from 'classnames'

import type { ReactElement } from 'react'
import type { IInApp } from '~/types/iap'

import { IapPeriodicityBadge } from '~/components/Badges'
import DoubleBadge from '~/components/DoubleBadge'
import dayjs from '~/utils/dayjs'

import './styles.scss'

export interface Props {
  className?: string
  inApp: IInApp
}

const InAppResume = ({ className, inApp }: Props): ReactElement => {
  /** Local state */

  const componentClasses = classNames('in-app-resume-component', className)

  const { app_key, created_at, default_price_usd, free_trial, periodicity, sku } = inApp

  const parsedCreatedAt = dayjs(created_at)

  /** Render */

  return (
    <div className={componentClasses}>
      <div className="in-app-resume-component__skus-container">
        <p className="in-app-resume-component__skus-container__sku" data-testid="sku-test-id">
          {sku}
        </p>
      </div>
      <div className="in-app-resume-component__infos-container">
        <div className="in-app-resume-component__infos-container__app-key">{app_key}</div>
        {periodicity ? <IapPeriodicityBadge value={periodicity} /> : null}
        {free_trial ? <DoubleBadge keyTag="Free trial" valueTag={free_trial} /> : null}
        <p className="in-app-resume-component__infos-container__price">
          <span className="fi fi-us" />
          {default_price_usd}$
        </p>
        <p className="in-app-resume-component__infos-container__created-at">Created {parsedCreatedAt.fromNow()}</p>
      </div>
    </div>
  )
}

export default InAppResume
